import PropTypes from 'prop-types';
import { useReducer } from 'react';

import CancelFlow from './CancelFlow';
import { CancelFlowContext, cancelFlowReducer, initialCancelFlowState } from './CancelFlowContext';
import { observabilityAppService } from '../../utils/ObservabilityAppService';
import { ErrorBoundary } from '../ErrorBoundary';
import { QueryClientProvider } from '../QueryClientProvider';

const CancelFlowWithContext = ({ cancelSuccessCallback }) => {
  const cancelFlowState = useReducer(cancelFlowReducer, { ...initialCancelFlowState, cancelSuccessCallback });

  return (
    <ErrorBoundary notifier={observabilityAppService}>
      <QueryClientProvider>
        <CancelFlowContext.Provider value={cancelFlowState}>
          <CancelFlow />
        </CancelFlowContext.Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

CancelFlowWithContext.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  cancelSuccessCallback: () => {},
};

CancelFlowWithContext.propTypes = {
  cancelSuccessCallback: PropTypes.func,
};

export default CancelFlowWithContext;
